<template>
  <div id="iframe-box">
    <p v-if="pid">PID: {{ pid }}</p>
    <iframe v-if="uri" :src="uri"></iframe>
  </div>
</template>

<script>
export default {
  name: "MonetaRepayForm",
  mounted() {
    this.uri = this.$parent.ctx.uri;
    this.pid = this.$parent.ctx.pid;
  },
  data() {
    return {
      uri: "",
      pid: ""
    };
  }
};
</script>

<style scoped>
#iframe-box, #iframe-box > iframe {
  width: 100%;
  height: auto;
  min-height: 650px;
}
</style>